// src/components/WhatsAppButton.js
import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import '../styles/home.css'

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/17207372513" // WhatsApp's "click to chat" link
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-4 right-4 bg-green-500 text-white p-4 rounded-full shadow-lg flex items-center justify-center hover:bg-green-600 transition-colors"
      style={{ zIndex: 9999 }}
    >
      <FaWhatsapp size={24} />
    </a>
  );
};

export default WhatsAppButton;
